import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconFacebook = props => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="m18 0h-16c-1.1 0-2 0.9-2 2v16c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-16c0-1.1-0.9-2-2-2zm-1 2v3h-2c-0.6 0-1 0.4-1 1v2h3v3h-3v7h-3v-7h-2v-3h2v-2.5c0-1.9 1.6-3.5 3.5-3.5h2.5z" />
  </SvgIcon>
);

export default IconFacebook;



// WEBPACK FOOTER //
// ./src/components/icons/IconFacebook.js